import { render } from "./AgentLeavingDetail.vue?vue&type=template&id=0b8c2979&scoped=true"
import script from "./AgentLeavingDetail.vue?vue&type=script&lang=js"
export * from "./AgentLeavingDetail.vue?vue&type=script&lang=js"

import "./AgentLeavingDetail.vue?vue&type=style&index=0&id=0b8c2979&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8c2979"]])

export default __exports__